import styled from '@emotion/styled'
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material'
import { Link as ReactRouterLink } from 'react-router'

export const Breadcrumbs = styled(MuiBreadcrumbs)`
	${({ theme }) => `
		margin-bottom: ${theme.spacing(2)};
		color: $(theme.palette.primary.main);
		font-size: $(theme.spacing(2));
	`}
	padding: 1rem 1rem 1rem 0rem;

	@media print {
		display: none !important;
	}
`

export const Link = styled(ReactRouterLink)`
	text-decoration: underline;
`
